import { useState } from "react";
import { CheckCircle2, Download, Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";

const OPEN = ["atelier", "testing", "report"];

// Publier (normal path: novelty + pré-pub) / Refuser (the live version stays). A failing blocking check needs an explicit override + reason.
export const ItemActions = ({ it, onDone }) => {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [reason, setReason] = useState("");
  const blocked = it.blocking?.length > 0;
  const go = async (path, body) => {
    setBusy(true);
    try {
      await api.post(`/admin/atelier/items/${it.id}/${path}`, body);
      toast.success(t(path === "publish" ? "atelier.publishedOk" : "atelier.rejectedOk"));
      setReason("");
      onDone();
    } catch (e) { toast.error(translateError(e, t)); }
    setBusy(false);
  };
  const apk = async () => {
    const { data } = await api.get(`/admin/atelier/items/${it.id}/apk`, { responseType: "blob" });
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(data), download: `${it.package || it.app_id}-${it.version}.apk` });
    a.click();
    URL.revokeObjectURL(a.href);
  };
  return (
    <div className="min-w-0 space-y-2" data-testid="atelier-item-actions">
      <button type="button" className="btn-red btn-sm" onClick={apk} data-testid="atelier-item-apk"><Download className="h-4 w-4" /> APK</button>
      {OPEN.includes(it.status) && (
        <>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={1000} placeholder={t(blocked ? "atelier.overrideReason" : "atelier.reason")}
            className="w-full min-w-0 rounded-lg border border-neutral-700 bg-black/40 px-3 py-2 text-sm text-white" data-testid="atelier-item-reason" />
          {blocked && <p className="break-words text-xs text-red-300" data-testid="atelier-item-blocked">{t("atelier.blockedHint", { list: it.blocking.map((c) => c.id).join(", ") })}</p>}
          <div className="flex flex-col gap-2 sm:flex-row">
            <button type="button" className="btn-gold btn-sm" disabled={busy || (blocked && reason.trim().length < 3)} data-testid="atelier-item-publish"
              onClick={() => go("publish", blocked ? { override: true, reason: reason.trim() } : { reason: reason.trim() })}>
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CheckCircle2 className="h-4 w-4" />} {t(blocked ? "atelier.publishOverride" : "atelier.publish")}
            </button>
            <button type="button" className="btn-red btn-sm" disabled={busy || reason.trim().length < 3} onClick={() => go("reject", { reason: reason.trim() })} data-testid="atelier-item-reject">
              <XCircle className="h-4 w-4" /> {t("atelier.reject")}
            </button>
          </div>
        </>
      )}
    </div>
  );
};
